{
  "aws_project_region": "us-east-2",
  "aws_appsync_graphqlEndpoint": "https://dfjzgwt2dbbh7aigsqfgqh4uuu.appsync-api.us-east-2.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_apiKey": "da2-4fc6vk3f5jesza4ewmx43z5a3a"
}